import React, { useEffect, useState } from 'react';
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import { NumericFormat } from 'react-number-format';
import './convenio.css'; // reutilizando o estilo

const Convenio = () => {
    const chapa = localStorage.getItem("chapa");
    const isMobile = window.innerWidth < 768;
    const [saldo, setSaldo] = useState(null);
    const [periodos, setPeriodos] = useState([]);
    const [detalhesVisiveis, setDetalhesVisiveis] = useState({});

    function formatNumber(amount, decimalCount = 2, decimal = ',', thousands = '.') {
        try {
            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
            amount = Number(amount) || 0;

            const negativeSign = amount < 0 ? '-' : '';
            let i = parseInt(Math.abs(amount).toFixed(decimalCount)).toString();
            let j = i.length > 3 ? i.length % 3 : 0;

            return (
                negativeSign +
                (j ? i.slice(0, j) + thousands : '') +
                i.slice(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
                (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
            );
        } catch (e) {
            console.error(e);
            return amount;
        }
    }

    const decodificarBase64 = (textoBase64) => {
        try {
            return atob(textoBase64);
        } catch (err) {
            console.error('Erro ao decodificar Base64:', err);
            return '';
        }
    };


    useEffect(() => {
        const carregarDados = async () => {
            try {
                const resSaldo = await api.get(`/aeflor/convenio/${chapa}`);
                setSaldo(resSaldo.data);
                const resPeriodos = await api.get(`/aeflor/convenio/${chapa}/periodo`);
                setPeriodos(resPeriodos.data);
            } catch (err) {
                console.error("Erro ao carregar dados do convênio", err);
                Swal.fire("Erro", "Não foi possível carregar os dados do convênio.", "error");
            }
        };

        carregarDados();
    }, [chapa]);

    const toggleDetalhes = async (index, periodo) => {
        const visiveis = { ...detalhesVisiveis };

        if (visiveis[index]) {
            visiveis[index] = null;
        } else {
            try {
                const res = await api.get(`/aeflor/convenio/${chapa}/consumo/${periodo}`);
                visiveis[index] = res.data;
            } catch (err) {
                console.error("Erro ao carregar compras do período", err);
                Swal.fire("Erro", "Sem registros de compra no período.", "error");
                return;
            }
        }

        setDetalhesVisiveis(visiveis);
    };

    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="container-fluid mt-4">
                <h3>Convênio</h3>

                {/* SALDO */}
                {saldo && (
                    <div className="card text-white bg-success mb-3">
                        <div className="card-body">
                            {saldo.sucesso === 'B' && saldo.motivobloqueio !== ""
                                ? <h5 className="text-center text-white">Convênio Bloqueado: {decodificarBase64(saldo.motivobloqueio)}</h5>
                                : (
                                    <>
                                        <h2 className="text-center info-saldoG">Saldo: R$ {formatNumber(saldo.limite - saldo.usado)}</h2>
                                        <div className="d-flex justify-content-between">
                                            <small className='info-saldo'>Corte: {saldo.datacorte}</small>
                                            <small className='info-saldo'>Pagamento: {saldo.datapgto}</small>
                                        </div>
                                    </>
                                )}
                        </div>
                    </div>
                )}

                {/* PERÍODOS */}
                {periodos.map((p, idx) => (
                    <div key={idx} className="card mb-2">
                        <div
                            className="card-header d-flex justify-content-between align-items-center"
                            onClick={() => toggleDetalhes(idx, p.periodo)}
                            style={{ cursor: 'pointer' }}
                        >
                            <span><strong>Período: {p.periodo.slice(0, 2)}/{p.periodo.slice(2)} - ({p.inicio} - {p.fim}) <p className="txt-usado">Utilizado: R$ {formatNumber(p.conv_valorconvenio)} </p></strong></span>
                            <span>{detalhesVisiveis[idx] ? '▲' : '▼'}</span>
                        </div>

                        {/* DETALHES DO PERÍODO */}
                        <div className={`collapse-wrapper ${detalhesVisiveis[idx] ? 'open' : ''}`}>
                            {detalhesVisiveis[idx] && (
                                <div className="card-body">
                                    {detalhesVisiveis[idx].length === 0 ? (
                                        <p className="text-muted">Nenhuma compra registrada neste período.</p>
                                    ) : (
                                        <table className="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Data/Hora</th>
                                                    <th className="text-center">Loja</th>
                                                    <th className="text-center">Nota</th>
                                                    <th className="text-center">Série</th>
                                                    <th className="text-center">Valor</th>
                                                    <th className="text-center">Convênio</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {detalhesVisiveis[idx].map((c, i) => (
                                                    <tr key={i}>
                                                        <td className="text-center">{c.conv_datavenda} {c.conv_hora}</td>
                                                        <td className="text-end">{c.conv_loja}</td>
                                                        <button
                                                            className="btn btn-link text-end"
                                                            onClick={() => window.open(
                                                                `https://consultadfe.fazenda.rj.gov.br/consultaNFCe/QRCode?p=${c.conv_idnfe}|2|1|3|525D610DB9E208DBFE0D0DF74667DED2118E24CB`,
                                                                '_blank'
                                                            )}
                                                        >
                                                        {c.conv_nota}
                                                        </button>
                                                        <td className="text-end">{c.conv_serie}</td>
                                                        <td className="text-end">{formatNumber(c.conv_valorcompra)}</td>
                                                        <td className="text-end">{formatNumber(c.conv_valorconvenio)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    );
};

export default Convenio;
